import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Chip } from '@side/pantry';
import { useGetTemplateDetails } from '@/views/Templates/hooks/useGetTemplateDetails';

export const TemplateTitle = () => {
  const theme = useTheme();
  const { template, loading } = useGetTemplateDetails();

  if (loading || !template) {
    return null;
  }

  if (!template.isReadOnly) {
    return template.name;
  }

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {template.name}
      <Chip
        label="Read only"
        variant="outlined"
        size="small"
        sx={{
          background: 'transparent',
          color: theme.palette.primary.contrastText,
          border: `1.5px solid ${theme.palette.primary.contrastText}`,
          marginRight: theme.spacing(1),
        }}
      />
    </Stack>
  );
};
